module.exports = __webpack_public_path__ + "img/en.b91b8e8c.png";